import { h } from 'preact'

import './searchbar.scss'

export function SearchBar(props) {
	return (
		<input class="searchbar" type="search" {...props} />
	)
}
